<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail"> 
            <div class="d-grid grid-prospect"> 
                @if(oportunidad) {
                    <div>
                        <div class="prospect-card"> 
                            <!-- Encabezado -->
                            <div class="d-grid prospect-title"> 
                                <div><h4 class="color-gray t-20">Oportunidad</h4></div> 
                                <div class="d-grid card-buttons-1 align-self-end">
                                    <div class="menu-container">                                    
                                        <div class="dropdown-container" (click)="$event.stopPropagation()">
                                            <button (click)="toggleActionsMenu('menu-' + oportunidad.oportunidad_id)" class="btn btn-round-outline">
                                                <img src="assets/svg/tridots.svg" class="center-svg">
                                            </button>
                                            <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + oportunidad.oportunidad_id">
                                                <button *ngIf="permissionService.hasPermission('Oportunidades', 'Eliminar')" class="dropdown-item" (click)="openMdlDeleteOpportunity(oportunidad.oportunidad_id)">Eliminar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="d-grid prospect-name"> 
                                    <div><img src="assets/svg/opportunities-icon.svg" alt=""></div>
                                    <div><h2 class="text-semibold">{{oportunidad?.nombre || '10 Tablets A12B-34'}}</h2></div>
                                </div>
                                <div class="d-flex flex-row gap-20">
                                    <div class="text-tag color-org text-center">
                                        <b>Última actualización:</b> 
                                        {{oportunidad?.fecha_actualizacion ? (oportunidad.fecha_actualizacion | date: 'dd/MM/yyyy') : '10/07/2025'}}
                                    </div>
                                </div>
                                <div class="d-grid card-buttons-2">
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openNewCall()"><img class="center-svg" src="assets/svg/call-icon.svg"></button>
                                        <h5>Llamada</h5>
                                    </div>
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openNewTask()"><img class="center-svg" src="assets/svg/task-icon.svg"></button>
                                        <h5>Tarea</h5>
                                    </div>
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openNewEvent()"><img class="center-svg" src="assets/svg/event-icon.svg"></button>
                                        <h5>Evento</h5>
                                    </div>
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openSendMail()"><img class="center-svg" src="assets/svg/mail-icon.svg"></button>
                                        <h5>Correo</h5>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="d-grid info-card-title">
                                        <h3>Información de la oportunidad</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div *ngIf="!editInfo"><img src="assets/svg/edit.svg" alt="" class="icon-clickable" (click)="toggleEdit('info')"></div>
                                            <div *ngIf="editInfo" class="d-flex gap-10">
                                            <button class="btn btn-primary" (click)="saveEdit('info')">
                                            Guardar
                                            </button>
                                            <button class="btn btn-outline" (click)="cancelEdit('info')">
                                            Cancelar
                                            </button>
                                        </div>
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="togleSection('info')"><img class="center-svg" [class.rotated]="!showInfoSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showInfoSection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Nombre de la oportunidad:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editNombre">
                                                        {{ oportunidad?.nombre || '10 Tablets A12B-34' }}
                                                        </ng-container>
                                                        <ng-template #editNombre>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableOportunidad.nombre"
                                                            placeholder="Nombre de la oportunidad"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Nombre de la cuenta:</td>
                                                    <td>
                                                        <span *ngIf="oportunidad?.cuenta" 
                                                              style="color: #EA5A10; text-decoration: underline; cursor: pointer;">
                                                            {{oportunidad.cuenta.nombre_empresa || 'Empresa Siroe'}}
                                                        </span>
                                                        <span *ngIf="!oportunidad?.cuenta">-</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Tipo de negocio:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editNegocio">
                                                        {{ oportunidad?.tipo_negocio || 'Compra Directa' }}
                                                        </ng-container>
                                                        <ng-template #editNegocio>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableOportunidad.tipo_negocio"
                                                            placeholder="Tipo de negocio"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Importe:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editImporte">
                                                        {{ oportunidad?.importe_actual  || 'Sin importe'| number: '1.0-0' }}
                                                        </ng-container>
                                                        <ng-template #editImporte>
                                                        <input
                                                            class="crm-input"
                                                            type="number"
                                                            [(ngModel)]="editableOportunidad.importe_actual"
                                                            placeholder="0"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td> Importe total contrato</td>
                                                    <td>
                                                            {{oportunidad?.importe_total_contrato || 'Sin importe' | number:'1.0-0'}}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>Fecha de cierre:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editFechaCierre">
                                                            {{ oportunidad?.fecha_cierre_formatted || '29/07/2025' }}
                                                        </ng-container>
                                                        <ng-template #editFechaCierre>
                                                        <input
                                                            class="crm-input"
                                                            type="date"
                                                            [(ngModel)]="editableOportunidad.fecha_cierre_estimada"
                                                        />
                                                        </ng-template>
                                                    </td>                                                </tr>
                                                <tr>
                                                    <td>Etapa:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editEtapa">
                                                        {{ oportunidad?.etapa || 'Seguimiento' }}
                                                        </ng-container>
                                                        <ng-template #editEtapa>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableOportunidad.etapa"
                                                            placeholder="Etapa"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Probabilidad (%):</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editProbabilidad">
                                                        {{ oportunidad?.probabilidad_formatted || '50%' }}
                                                        </ng-container>
                                                        <ng-template #editProbabilidad>
                                                        <input
                                                            class="crm-input"
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            [(ngModel)]="editableOportunidad.probabilidad"
                                                            placeholder="0"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Siguiente paso:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editInfo; else editPaso">
                                                        {{ oportunidad?.siguiente_paso || '-' }}
                                                        </ng-container>
                                                        <ng-template #editPaso>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableOportunidad.siguiente_paso"
                                                            placeholder="Siguiente paso"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Información adicional</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div *ngIf="!editExtra"><img src="assets/svg/edit.svg" class="icon-clickable" (click)="toggleEdit('extra')" alt=""></div>
                                            <div *ngIf="editExtra" class="d-flex gap-10">
                                            <button class="btn btn-primary" (click)="saveEdit('extra')">
                                            Guardar
                                            </button>
                                            <button class="btn btn-outline" (click)="cancelEdit('extra')">
                                            Cancelar
                                            </button>
                                        </div>
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="togleSection('extra')"><img class="center-svg" [class.rotated]="!showExtraSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showExtraSection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Categoría de previsión:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editExtra; else editCategoria">
                                                        {{ oportunidad?.categoria_prevision || 'Máximo previsto' }}
                                                        </ng-container>
                                                        <ng-template #editCategoria>
                                                        <select
                                                            class="crm-input"
                                                            [(ngModel)]="editableOportunidad.categoria_prevision"
                                                        >
                                                            <option value="Omitida">Omitida</option>
                                                            <option value="Oportunidades en curso">Oportunidades en curso</option>
                                                            <option value="Maximo previsto">Máximo previsto</option>
                                                            <option value="Confirmar">Confirmar</option>
                                                            <option value="Cerrado">Cerrado</option>
                                                        </select>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Tipo:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editExtra; else editTipo">
                                                        {{ oportunidad?.tipo_oportunidad || '-' }}
                                                        </ng-container>
                                                        <ng-template #editTipo>
                                                        <select
                                                            class="crm-input"
                                                            [(ngModel)]="editableOportunidad.tipo_oportunidad"
                                                        >
                                                            <option value="Negocio existente">Negocio existente</option>
                                                            <option value="Nuevo negocio">Nuevo negocio</option>
                                                        </select>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Motivo de perdida:</td>
                                                     <td>
                                                        <ng-container *ngIf="!editExtra; else editMotivo">
                                                        {{ oportunidad?.motivo_perdida || '-' }}
                                                        </ng-container>
                                                        <ng-template #editMotivo>
                                                        <select
                                                            class="crm-input"
                                                            [(ngModel)]="editableOportunidad.motivo_perdida"
                                                        >
                                                            <option value="Competencia">Competencia</option>
                                                            <option value="Sin presupuesto">Sin presupuesto</option>
                                                            <option value="No respondio mas">No respondió más</option>
                                                            <option value="Precio">Precio</option>
                                                            <option value="Otro">Otro</option>
                                                            <option value="Fuera de plazo">Fuera de plazo</option>
                                                        </select>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Descripción:</td>
                                                    <td>
                                                    <ng-container *ngIf="!editExtra; else editNotas">
                                                    {{ oportunidad?.notas || '-' }}
                                                    </ng-container>
                                                    <ng-template #editNotas>
                                                    <textarea
                                                        class="crm-input"
                                                        rows="3"
                                                        [(ngModel)]="editableOportunidad.notas"
                                                    ></textarea>
                                                    </ng-template>
                                                </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                              <!--   <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Otra información</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div><img src="assets/svg/edit.svg" alt=""></div>
                                            <div class="d-grid"><button class="btn btn-round-outline-mini"><img class="center-svg" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Contrato:</td>
                                                    <td>{{oportunidad?.contrato || '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Presupuesto sincronizado:</td>
                                                    <td>{{oportunidad?.presupuesto_sincronizado || '-'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div> -->

                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Historial registro</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="togleSection('history')"><img class="center-svg" [class.rotated]="!showHistorySection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showHistorySection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Creado por:</td>
                                                    <td>
                                                        <div class="d-flex flex-row align-items-center color-org">
                                                            <img src="assets/svg/avatar.svg" alt="">
                                                            <u>{{oportunidad?.creadoPor.nombre}} {{oportunidad?.creadoPor.apellido}}</u>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{oportunidad?.fecha_creacion ? (oportunidad.fecha_creacion | date: 'dd/MM/yyyy HH:mm') : '10/07/2025 13:50'}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Modificado por:</td>
                                                    <td>
                                                        <div class="d-flex flex-row align-items-center color-org">
                                                            <img src="assets/svg/avatar.svg" alt="">
                                                            <u>{{oportunidad?.actualizadoPor.nombre}} {{oportunidad?.actualizadoPor.apellido}}</u>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{oportunidad?.fecha_actualizacion ? (oportunidad.fecha_actualizacion | date: 'dd/MM/yyyy HH:mm') : '10/07/2025 13:50'}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="prospect-info">
                        <div class="main-open-tab">
                            <div class="open-tab-title">
                                <div class="d-grid tab-title-detail">
                                    <div><h3 class="text-semibold">Etapas</h3></div>
                                    <div class="justify-self-end">
                                    <button class="btn btn-primary" (click)="updateOpportunityStatus()">
                                        Marcar etapa como completada
                                    </button>
                                    </div>
                                </div>
                                
                                <div class="d-grid progress-status-2 mt-3">
                                    @for(item of progreso_estado.slice(0,5); track item; let i = $index){
                                        <div [ngClass]="{
                                            'status-number-one' : item.estado.orden === 1, 
                                            'status-number-two' : item.estado.orden === 2 || item.estado.orden === 3 || item.estado.orden === 4, 
                                            'status-number-three' : item.estado.orden === 5 || i === 4,
                                            'active' : item.completado === true,
                                            'inactive' : item.completado === false || item.completado === null,
                                            'status-clicked' : markedStatus === item.estado.id_estado
                                        }" (click)="markStatus(item.estado.id_estado, i)">
                                            <span class="status-text">{{i === 4 ? 'Cerrada' : item.estado.nombre}}</span>
                                        </div>
                                    }
                                </div>
                                <div class="d-flex progress-status mt-3 flex-wrap gap-2">

                                    <!-- <div class="status-card-1">
                                        <div class="content-card-1 color-org text-center">
                                        <b>Asignado</b>
                                        </div>
                                    </div>

                                    <div class="status-card-2 status-inactive">
                                        <div class="content-card-2 color-org content-inactive text-center">
                                        <b>Presentación propuesta</b>
                                        </div>
                                    </div>

                                    <div class="status-card-2 status-inactive">
                                        <div class="content-card-2 color-org content-inactive text-center">
                                        <b>Seguimiento</b>
                                        </div>
                                    </div>

                                    <div class="status-card-2 status-inactive">
                                        <div class="content-card-2 color-org content-inactive text-center">
                                        <b>Recepción OC</b>
                                        </div>
                                    </div>

                                    <div class="status-card-2 status-inactive">
                                        <div class="content-card-2 color-org content-inactive text-center">
                                        <b>Entrega</b>
                                        </div>
                                    </div>

                                    <div class="status-card-3 status-inactive">
                                        <div class="content-card-3 color-org content-inactive text-center">
                                        <b>Cerrada</b>
                                        </div>
                                    </div> -->
                                </div>
                                <h3 class="mt-3"><b>Acciones clave por etapa</b></h3>
                                @for(item of oppSteps?.actions; track item.item){
                                    <div class="d-grid action-elm mt-3">
                                        <div><img class="center-svg" src="assets/svg/action-check.svg" alt=""></div>
                                        <div><h4 class="text-light">{{item.texto}}</h4></div>
                                    </div>
                                }
                            </div>
                        </div> 
                        <div class="detail-container white-bg mt-5">
                            <app-nav-opportunities></app-nav-opportunities>
                        </div>
                    </div>


                    
                } @else {
                    <div class="no-opportunity-message">
                        @if(isLoading) {
                            <p>Cargando oportunidad...</p>
                        } @else {
                            <p>{{errorMessage || 'No se encontró información de la oportunidad'}}</p>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>